import { Element, Page } from './shared'

export const SHARED_FEATURES_SELECTORS = {
  // WLoader.vue -- the `sectionTag` prop default for the shared Wasabi loader.
  WASABI_LOADER: `wasabi-${Element.LOADER}`,
  // WTab.stories.ts -- stable caller-owned alias for the slug-collision example.
  WASABI_TAB_STABLE_ALIAS: `wasabi-tab-open-now-spaced-${Element.TAB}`,
  // ReplyToCustomerModal.vue -- the `sectionTag` prop default, and the base its descendants compose
  // from. Sibling of REPLY_GUEST above; both are Pendo-tracked families.
  REPLY_TO_CUSTOMER: 'reply-to-customer',
  // RedactedText.vue -- the `sectionTag` prop default.
  REDACTED_TEXT: 'redacted-text',
  // RedactedState.vue -- the `sectionTag` prop default.
  REDACTED_STATE: 'redacted-state',
  // FlagAttachment.vue -- the `sectionTag` prop default.
  FLAG_ATTACHMENT_MODAL: `flag-attachment-${Element.MODAL}`,
  // AddressSearch.vue -- the `sectionTag` prop default, and the base its `-preview`, `-address-line1`,
  // `-address-line2` and `-verified` descendants compose from.
  ADDRESS_SEARCH: 'address-search',
  // ReplyGuest.vue — the `sectionTag` prop default, and the base its descendants compose from
  // (`-send`, `-cancel`, `-subject`, the template items). Pendo tracks 8 features off that family,
  // so the value is load-bearing beyond this repo.
  REPLY_GUEST: 'reply-guest',
  // ActionItemModalForm.vue
  ACTION_ITEM_FORM_MODAL: 'action-item-form',
  ACTION_ITEM_FORM_DESCRIPTION_INPUT_FIELD: 'action-item-form-description',
  ACTION_ITEM_FORM_FACTORS_DROPDOWN: 'action-item-form-factors',

  ACTION_ITEM_FORM_CHIP: 'action-item-form-chip',

  // ActionItemElement.vue
  ACTION_ITEM_CARD: 'action-item-card',
  ACTION_ITEM_STATUS: 'action-item-status',
  ACTION_ITEM_SOURCE: 'action-item-source',
  ACTION_ITEM_DESCRIPTION: 'action-item-description',
  ACTION_ITEM_EDIT_BUTTON: `action-item-edit-${Element.BUTTON}`,
  ACTION_ITEM_DELETE_BUTTON: `action-item-delete-${Element.BUTTON}`,
  ACTION_ITEM_NEW_TAG: 'action-items-new-tag',
  ACTION_ITEM_VIEW_MORE_BUTTON: `action-item-view-more-${Element.BUTTON}`,
  ACTION_ITEM_AI_ICON: `action-item-ai-${Element.ICON}`,

  // ChangeLocationModal.vue
  CHANGE_LOCATION_MODAL: `change-location-${Element.MODAL}`,
  CHANGE_LOCATION_SELECT_DROPDOWN: 'change-location-select',

  // ManagerRepliesTable.vue
  MANAGER_REPLIES_WRAPPER: `${Page.ENHANCED_PROFILE}-manager-replies-wrapper`,
  MANAGER_REPLIES_TABLE: `${Page.ENHANCED_PROFILE}-manager-replies-${Element.TABLE}`,
  MANAGER_REPLIES_VIEW_EMAIL_BUTTON: `${Page.ENHANCED_PROFILE}-view-email-${Element.BUTTON}`,
  MANAGER_REPLIES_VIEW_EMAIL_MODAL: `${Page.ENHANCED_PROFILE}-view-email-${Element.MODAL}`,

  // RewardsTable.vue
  REWARDS_WRAPPER: `${Page.ENHANCED_PROFILE}-rewards-${Element.TABLE}`,
  REWARDS_TABLE: `${Page.ENHANCED_PROFILE}-rewards`,

  // EditTagsModal.vue
  EDIT_TAGS_MODAL: 'edit-tags',
  EDIT_TAGS_TAG_SELECTOR_DROPDOWN: 'edit-tags-modal-tag-selector',

  EDIT_TAGS_CHIP: 'edit-tags-modal-chip',

  // CustomerDetails.vue (responses-panels)
  CUSTOMER_DETAILS_AVATAR: 'incident-details',
  CUSTOMER_DETAILS_COPY_EMAIL: 'incident-details-copy-email',
  CUSTOMER_DETAILS_NEW_TAG: 'incident-details-new-tag',
  INCIDENT_DETAILS_CUSTOMER_NAME: 'incident-details-customer-name',
  INCIDENT_DETAILS_CUSTOMER_EMAIL: 'incident-details-customer-email',
  INCIDENT_DETAILS_CUSTOMER_PHONE: 'incident-details-customer-phone',
  INCIDENT_DETAILS_ANONYMOUS_ICON: `incident-details-anonymous-${Element.ICON}`,

  // FeedbackDetails.vue (responses-panels)
  FEEDBACK_DETAILS_CONTAINER: 'feedback-details',
  FEEDBACK_DETAILS_ACCORDION: `feedback-details-${Element.ACCORDION}`,
  FEEDBACK_DETAILS_ACCORDION_ITEM: 'feedback-details-accordion-item',

  // CustomerSummary.vue (responses-panels)
  CUSTOMER_SUMMARY_TITLE: `customer-summary-${Element.TITLE}`,
  CUSTOMER_SUMMARY_AVG_SPEND_LABEL: `customer-summary-avg-spend-${Element.LABEL}`,
  CUSTOMER_SUMMARY_AVG_SPEND_VALUE: 'customer-summary-avg-spend-value',
  CUSTOMER_SUMMARY_RESPONSES_LABEL: `customer-summary-responses-${Element.LABEL}`,
  CUSTOMER_SUMMARY_RESPONSES_VALUE: 'customer-summary-responses-value',
  CUSTOMER_SUMMARY_AVG_RATING_LABEL: `customer-summary-avg-rating-${Element.LABEL}`,
  CUSTOMER_SUMMARY_AVERAGE_RATING: 'customer-summary-average-rating',
  CUSTOMER_SUMMARY_GUEST_SINCE_LABEL: `customer-summary-guest-since-${Element.LABEL}`,
  CUSTOMER_SUMMARY_GUEST_SINCE_VALUE: 'customer-summary-guest-since-value',
  CUSTOMER_SUMMARY_CUSTOMER_SINCE_TOOLTIP: `customer-summary-customer-since-${Element.TOOLTIP}`,

  // AdditionalQuestionsDetails.vue (responses-panels)
  ADDITIONAL_QUESTIONS_ACCORDION: 'additional-questions',
  ADDITIONAL_QUESTIONS_ACCORDION_ITEM: 'additional-questions-accordion-item',
  ADDITIONAL_QUESTIONS_QUESTION: 'additional-questions-question',
  ADDITIONAL_QUESTIONS_DATA_BUTTON: `additional-questions-additional-data-${Element.BUTTON}`,
  ADDITIONAL_QUESTIONS_WEIGHT_UP_ICON: `additional-questions-weight-up-${Element.ICON}`,
  ADDITIONAL_QUESTIONS_WEIGHT_DOWN_ICON: `additional-questions-weight-down-${Element.ICON}`,
  ADDITIONAL_QUESTIONS_DOWNLOAD_LINK: `additional-questions-download-${Element.LINK}`,
  ADDITIONAL_QUESTIONS_CANCEL_BUTTON: `additional-questions-cancel-${Element.BUTTON}`,
  ADDITIONAL_QUESTIONS_UPDATE_BUTTON: `additional-questions-update-${Element.BUTTON}`,

  // FeedbackDetailsContent.vue (responses-panels)
  FEEDBACK_DETAILS_LOCATION_CHANGE: 'feedback-details-location-change',
  FEEDBACK_DETAILS_PROVIDED_TOOLTIP: `feedback-details-provided-${Element.TOOLTIP}`,
  FEEDBACK_DETAILS_EXPERIENCED_TOOLTIP: `feedback-details-experienced-${Element.TOOLTIP}`,
  FEEDBACK_DETAILS_FLAG_FOR_REVIEW: 'feedback-details-flag-for-review',
  INCIDENT_DETAILS_LOCATION_TITLE: `incident-details-location-${Element.TITLE}`,
  INCIDENT_DETAILS_SOURCE_OF_FEEDBACK_LABEL: `incident-details-source-of-feedback-${Element.LABEL}`,
  INCIDENT_DETAILS_SOURCE_OF_FEEDBACK_VALUE: 'incident-details-source-of-feedback-value',
  INCIDENT_DETAILS_LOCATION_LABEL: `incident-details-location-${Element.LABEL}`,
  INCIDENT_DETAILS_LOCATION_VALUE: 'incident-details-location-value',
  INCIDENT_DETAILS_LOCATION_ICON: `incident-details-location-${Element.ICON}`,
  INCIDENT_DETAILS_QUESTIONNAIRE_LABEL: `incident-details-questionnaire-${Element.LABEL}`,
  INCIDENT_DETAILS_QUESTIONNAIRE_VALUE: 'incident-details-questionnaire-value',
  INCIDENT_DETAILS_CREATED_LABEL: `incident-details-created-${Element.LABEL}`,
  INCIDENT_DETAILS_CREATED_VALUE: 'incident-details-created-value',
  INCIDENT_DETAILS_PROVIDED_LABEL: `incident-details-provided-${Element.LABEL}`,
  INCIDENT_DETAILS_PROVIDED_VALUE: 'incident-details-provided-value',
  INCIDENT_DETAILS_EXPERIENCED_LABEL: `incident-details-experienced-${Element.LABEL}`,
  INCIDENT_DETAILS_EXPERIENCED_VALUE: 'incident-details-experienced-value',
  INCIDENT_DETAILS_EXPERIENCED_ICON: `incident-details-experienced-${Element.ICON}`,
  INCIDENT_DETAILS_QUESTIONNABLE_FEEDBACK_LABEL: `incident-details-questionnable-feedback-${Element.LABEL}`,
  INCIDENT_DETAILS_FLAG_FOR_REVIEW_LABEL: `feedback-details-flag-for-review-${Element.LABEL}`,
  INCIDENT_DETAILS_FLAG_FOR_REVIEW_BY_LABEL: `incident-details-flag-for-review-by-${Element.LABEL}`,
  INCIDENT_DETAILS_FLAG_FOR_REVIEW_ICON: `feedback-details-flag-for-review-${Element.ICON}`,

  // OrderDetails.vue (responses-panels)
  ORDER_DETAILS_CONTAINER: 'order-details',
  ORDER_DETAILS_ACCORDION: `order-details-${Element.ACCORDION}`,
  ORDER_DETAILS_ACCORDION_ITEM: 'order-details-accordion-item',

  // OrderDetailsContent.vue (responses-panels)
  ORDER_DETAILS_CONTENT_LOADER: `order-details-content-${Element.LOADER}`,
  ORDER_DETAILS_CONTENT_REGION: 'order-details-content-loading-region',
  ORDER_DETAILS_CONTENT_ERROR: `order-details-content-${Element.ERROR}`,
  ORDER_DETAILS_CONTENT_RETRY: `order-details-content-retry-${Element.BUTTON}`,
  ORDER_DETAILS_CONTENT_REFRESH_RETRY: `order-details-content-refresh-retry-${Element.BUTTON}`,
  ORDER_DETAILS_EXTERNAL_ID: 'order-details-external-id',
  ORDER_DETAILS_NUMBER_LABEL: `order-details-number-${Element.LABEL}`,
  ORDER_DETAILS_AMOUNT_LABEL: `order-details-amount-${Element.LABEL}`,
  ORDER_DETAILS_AMOUNT_VALUE: 'order-details-amount-value',
  ORDER_DETAILS_REFERRAL_LABEL: `order-details-referral-${Element.LABEL}`,
  ORDER_DETAILS_REFERRAL_VALUE: 'order-details-referral-value',
  ORDER_DETAILS_DELIVERY_LABEL: `order-details-delivery-${Element.LABEL}`,
  ORDER_DETAILS_DELIVERY_VALUE: 'order-details-delivery-value',
  ORDER_DETAILS_DELIVERED_BY_LABEL: `order-details-delivered-by-${Element.LABEL}`,
  ORDER_DETAILS_DELIVERED_BY_VALUE: 'order-details-delivered-by-value',
  ORDER_DETAILS_ITEMS_LABEL: `order-details-items-${Element.LABEL}`,
  ORDER_DETAILS_ITEM_RATING: 'order-details-item',
  ORDER_DETAILS_PHOTO_LABEL: `order-details-photo-${Element.LABEL}`,
  ORDER_DETAILS_VIEW_ITEM_PHOTO: 'order-details-view-item-photo',
  ORDER_DETAILS_PHOTO_MODAL: 'order-details-photo',

  // OperationalCategoriesDetails.vue (responses-panels)
  OPERATIONAL_CATEGORIES_ACCORDION: `operational-categories-${Element.ACCORDION}`,
  OPERATIONAL_CATEGORIES_ACCORDION_ITEM: 'operational-categories-accordion-item',
  OPERATIONAL_CATEGORY: 'operational-category',
  OPERATIONAL_CATEGORIES_DELETE_BUTTON: `operational-categories-delete-${Element.BUTTON}`,
  OPERATIONAL_CATEGORIES_DELETE_ICON: `operational-categories-delete-${Element.ICON}`,
  OPERATIONAL_CATEGORIES_CANCEL_BUTTON: `operational-categories-cancel-${Element.BUTTON}`,
  OPERATIONAL_CATEGORIES_UPDATE_BUTTON: `operational-categories-update-${Element.BUTTON}`,

  // PreviousFeedback.vue (responses-panels)
  PREVIOUS_FEEDBACK_CONTAINER: `incident-details-previous-feedback-${Element.CONTAINER}`,
  PREVIOUS_FEEDBACK_ACCORDION: `previous-feedback-${Element.ACCORDION}`,
  PREVIOUS_FEEDBACK_ACCORDION_ITEM: 'previous-feedback-accordion-item',

  // PreviousFeedbackContent.vue (responses-panels)
  PREVIOUS_FEEDBACK_TABLE: `incident-details-previous-feedback-${Element.TABLE}`,
  PREVIOUS_FEEDBACK_EMPTY_STATE: 'incident-details-previous-feedback-empty-state',
  PREVIOUS_FEEDBACK_LOADING_REGION: 'incident-details-previous-feedback-loading-region',
  PREVIOUS_FEEDBACK_ERROR: `incident-details-previous-feedback-${Element.ERROR}`,
  PREVIOUS_FEEDBACK_RETRY: `incident-details-previous-feedback-retry-${Element.BUTTON}`,
  PREVIOUS_FEEDBACK_REFRESH_RETRY: `incident-details-previous-feedback-refresh-retry-${Element.BUTTON}`,

  // RewardsDetails.vue (responses-panels)
  REWARDS_DETAILS_CONTAINER: 'rewards-details',
  REWARDS_DETAILS_ACCORDION: `rewards-details-${Element.ACCORDION}`,
  REWARDS_DETAILS_ACCORDION_ITEM: 'rewards-details-accordion-item',
  REWARDS_DETAILS_ERROR: `rewards-details-${Element.ERROR}`,
  REWARDS_DETAILS_RETRY: `rewards-details-retry-${Element.BUTTON}`,
  REWARDS_DETAILS_REFRESH_RETRY: `rewards-details-refresh-retry-${Element.BUTTON}`,

  // RewardsDetailsContent.vue (responses-panels)
  REWARDS_DETAILS_CONTENT_LOADER: `rewards-details-content-${Element.LOADER}`,
  REWARDS_DETAILS_CONTENT_REGION: 'rewards-details-content-loading-region',
  REWARDS_DETAILS_REWARD_LABEL: 'rewards-details-reward-label',

  // RewardsDetails.vue (responses-panels)
  REWARDS_DETAILS_TITLE: `rewards-details-${Element.TITLE}`,

  // ReviewedList.vue (case-management)
  CASE_MANAGEMENT_REVIEWED_LIST_TOOLTIP: `case-management-reviewed-list-${Element.TOOLTIP}`,

  // StageThread.vue (case-management)
  CASE_MANAGEMENT_STAGE_THREAD: 'case-management-stage-thread',

  // StageThreadInteraction.vue (case-management)
  CASE_MANAGEMENT_FLAG_ATTACHMENT: 'case-management-flag-attachment',

  // ThreadDrawer.vue (case-management)
  THREAD_DRAWER_PROGRESS_BAR: 'thread-drawer-progress-bar',
  THREAD_DRAWER_LOADING_REGION: 'thread-drawer-loading-region',
  THREAD_DRAWER_LOADER: `thread-drawer-${Element.LOADER}`,
  THREAD_DRAWER_ERROR: `thread-drawer-${Element.ERROR}`,
  THREAD_DRAWER_RETRY: `thread-drawer-retry-${Element.BUTTON}`,
  THREAD_DRAWER_REFRESH_ERROR: `thread-drawer-refresh-${Element.ERROR}`,
  THREAD_DRAWER_REFRESH_RETRY: `thread-drawer-refresh-retry-${Element.BUTTON}`,
  THREAD_DRAWER_CLOSE_BUTTON: 'thread-drawer-close',

  // ReplyGuest.vue's trigger + 5 menu-item selectors are sectionTag-parameterized at the
  // component (TE-13047) — two ReplyGuest instances mount simultaneously per page (desktop +
  // hidden mobile thread-drawer), so a flat static constant here would collide. See
  // ReplyGuest.vue for the composed values.

  // TimeLine.vue (case-management)
  TIMELINE_STAGE_ICON: `timeline-stage-${Element.ICON}`,

  // RecoveredDetails.vue (case-management)
  TIMELINE_RECOVERED_DETAILS_CURRENCY_ICON: `timeline-recovered-details-currency-${Element.ICON}`,

  // ReplyToCustomerModal.vue (reply-guest)
  CUSTOMER_INSIGHTS_ACCORDION: 'customer-insights',
  CUSTOMER_INSIGHTS_ACCORDION_ITEM: 'customer-insights-details',
  CUSTOMER_INSIGHTS_LOADER: 'customer-insights-loading',
  AI_REPLY_LOADING_REGION: 'ai-reply-loading',
  AI_INSIGHTS_SEVERITY_TOOLTIP: `reply-guest-ai-insights-severity-${Element.TOOLTIP}`,
  AI_ACTION_BUTTON: `reply-to-customer-ai-action-${Element.BUTTON}`,
  USE_TEMPLATE_BUTTON: `reply-to-customer-use-template-${Element.BUTTON}`,
  REPLY_BODY_INPUT: `reply-to-customer-body-${Element.INPUT}`,
  REPLY_YELP_ERROR: `reply-to-customer-yelp-${Element.ERROR}`,
  TEMPLATE_POPOVER: 'reply-to-customer-template-popover',
  REPLY_TO_CUSTOMER_INSIGHTS_TITLE_ICON: `reply-to-customer-insights-${Element.TITLE}-${Element.ICON}`,
  INCIDENT_DETAILS_CUSTOMER_INSIGHTS_SEVERITY_LEVEL: 'incident-details-customer-insights-severity-level',
  INCIDENT_DETAILS_CUSTOMER_INSIGHTS_KEY_POINT: 'reply-guest-customer-insights-key-point',

  // NotificationPreferencesEditor.vue
  NOTIFICATION_PREFERENCES_TOGGLE: 'notification-preferences',
  NOTIFICATION_PREFERENCES_LOADER: `notification-preferences-${Element.LOADER}`,
  NOTIFICATION_PREFERENCES_ERROR: `notification-preferences-${Element.ERROR}`,
  NOTIFICATION_PREFERENCES_RETRY: `notification-preferences-retry-${Element.BUTTON}`,
  NOTIFICATION_PREFERENCES_REFRESH_ERROR: `notification-preferences-refresh-${Element.ERROR}`,
  NOTIFICATION_PREFERENCES_REFRESH_RETRY: `notification-preferences-refresh-retry-${Element.BUTTON}`,
  NOTIFICATION_PREFERENCES_SUMMARIES: 'notification-preferences-summaries',
  NOTIFICATION_PREFERENCES_INSTANT: 'notification-preferences-instant',
  NOTIFICATION_PREFERENCES_INCIDENTS: 'notification-preferences-incidents',
  NOTIFICATION_PREFERENCES_INCIDENTS_TOOLTIP: `incidents-${Element.TOOLTIP}`,
  NOTIFICATION_PREFERENCES_CONTACT_SUBMISSIONS: 'notification-preferences-contact-submissions',
  NOTIFICATION_PREFERENCES_ONLINE_REVIEWS: 'notification-preferences-online-reviews',
  NOTIFICATION_PREFERENCES_INSTANT_STAR_RATING: 'notification-preferences-instant-star-rating',
  NOTIFICATION_PREFERENCES_ONLINE_REVIEW_STAR_RATING: 'notification-preferences-online-review-star-rating',

  // NotificationPreferencesEditor.vue
  NOTIFICATION_PREFERENCES_SKELETON_SECTION: 'notification-preferences-skeleton-section',
  NOTIFICATION_PREF_INSTANT_STAR_HEADING: 'notification-pref-instant-star-heading',
  NOTIFICATION_PREF_INSTANT_STAR_HINT: 'notification-pref-instant-star-hint',
  NOTIFICATION_PREF_REVIEW_STAR_HEADING: 'notification-pref-review-star-heading',
  NOTIFICATION_PREF_REVIEW_STAR_HINT: 'notification-pref-review-star-hint',
  INCIDENT_DETAILS_TAG: 'incident-details-tag',
  ACTION_ITEM_REASON: 'action-item-reason',
  CITATION: 'citation',
  CITATION_PILL: `citation-${Element.PILL}`,
  INCIDENT_DETAILS_PREVIOUS_FEEDBACK: 'incident-details-previous-feedback',
  MANAGER_REPLY_RATING: 'manager-reply-rating',
  OPERATIONAL_CATEGORY_ANSWER: 'operational-category-answer',
  OPERATIONAL_CATEGORY_COMMENT: 'operational-category-comment',
  OPERATIONAL_CATEGORY_PILL: `operational-category-${Element.PILL}`,
  OPERATIONAL_CATEGORY_RATING: 'operational-category-rating',
  OPERATIONAL_CATEGORY_RATING_EDIT: 'operational-category-rating-edit',
  OPERATIONAL_CATEGORY_REASON: 'operational-category-reason',
  OPERATIONAL_CATEGORY_WEIGHT: 'operational-category-weight',
  REWARD_RATING: 'reward-rating',
  REWARD_SCORE: 'reward-score',
  REWARD_STATUS: 'reward-status'
} as const
